<template>
    <div class="container">
        <div v-if="$store.getters.hasGatehousePerm('change_guestbook')" class="mb-3">
            <button
                class="btn btn-primary btn-sm px-3 py-2 d-flex flex-row justify-content-center align-items-center"
                @click="goToEdit"
            >
                <icon icon="Edit"></icon>
                <span class="ms-2 fs-6 text-white fw-bold">{{ $t("utils.editDetails") }}</span>
            </button>
        </div>
        <div class="card">
            <div class="card-header">
                <h3>{{ $t("headers.guestbookDetail") }}</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("guestbook.name") }}</dt>
                            <dd class="col-sm-8">{{ guestbook.guest_name }}</dd>

                            <dt class="col-sm-4">{{ $t("guestbook.company") }}</dt>
                            <dd class="col-sm-8">{{ guestbook.company }}</dd>

                            <dt class="col-sm-4">{{ $t("guestbook.cardNumber") }}</dt>
                            <dd class="col-sm-8">{{ guestbook.personal_card_number }}</dd>

                            <dt class="col-sm-4">{{ $t("guestbook.cardType") }}</dt>
                            <dd class="col-sm-8">{{ guestbook.personal_card_type ? $t("documentType." + guestbook.personal_card_type) : "-" }}</dd>

                            <dt class="col-sm-4">{{ $t("guestbook.from") }}</dt>
                            <dd class="col-sm-8">
                                {{ guestbook.expected_from ? $d(new Date(guestbook.expected_from), 'short') : "—" }}
                            </dd>

                            <dt class="col-sm-4">{{ $t("guestbook.to") }}</dt>
                            <dd class="col-sm-8">
                                {{ guestbook.expected_to ? $d(new Date(guestbook.expected_to), 'short') : "-" }}
                            </dd>
                        </dl>
                    </div>
                    <div class="col-md-6">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("status.status") }}</dt>
                            <dd class="col-sm-8">
                                <span>{{ guestbook.status_name ? $t("status.guestbook." + guestbook.status_name) : "-" }}</span>
                                <button
                                    v-if="$store.getters.hasGatehousePerm('change_status_guestbook')"
                                    class="btn btn-primary fw-bold text-white p-2 ms-3"
                                    data-bs-toggle="modal"
                                    data-bs-target="#statusModal"
                                >
                                    {{ $t("utils.change") }}
                                </button>
                            </dd>

                            <!-- <dt class="col-sm-4">{{ $t("guestbook.signatureArrival") }}</dt>
                            <dd class="col-sm-8">
                                <div v-if="!signatureImages.arrival">
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2 me-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#signatureModal"
                                        @click="openSignatureModal('arrival')"
                                    >
                                        {{ $t("utils.add") }}
                                    </button>
                                </div>
                                <div v-else>
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2 me-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#viewModal"
                                        @click="openViewModal('arrival')"
                                    >
                                        {{ $t("utils.view") }}
                                    </button>
                                </div>
                            </dd> -->

                            <div class="col-12">
                                <h5>{{ $t("guestbook.signatureArrival") }}</h5>
                                <div v-if="!signatureImages.arrival">
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2 me-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#signatureModal"
                                        @click="openSignatureModal('arrival')"
                                    >
                                        {{ $t("utils.add") }}
                                    </button>
                                </div>
                                <div v-else>
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2 me-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#viewModal"
                                        @click="openViewModal('arrival')"
                                    >
                                        {{ $t("utils.view") }}
                                    </button>
                                </div>
                            </div>

                            <div class="col-12">
                                <h5>{{ $t("guestbook.signatureDeparture") }}</h5>
                                <div v-if="!signatureImages.departure">
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#signatureModal"
                                        @click="openSignatureModal('departure')"
                                    >
                                        {{ $t("utils.add") }}
                                    </button>
                                </div>
                                <div v-else>
                                    <button
                                        type="button"
                                        class="btn btn-primary fw-bold text-white p-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#viewModal"
                                        @click="openViewModal('departure')"
                                    >
                                        {{ $t("utils.view") }}
                                    </button>
                                </div>

                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal for adding signatures -->
    <div class="modal fade" id="signatureModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">{{ modalTitle }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body mx-auto">
                    <canvas ref="canvas" class="canvas" width="400" height="200"></canvas>
                </div>
                <div class="modal-footer border-top-0 mb-2">
                    <div class="d-flex justify-content-center gap-4 w-100">
                        <button type="button" class="btn btn-danger" @click="clearCanvas">{{ $t("utils.delete") }}</button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveCanvas">{{ $t("utils.save") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal for signature view -->
    <div class="modal fade" id="viewModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">{{ modalTitle }}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body mx-auto">
                    <img
                        v-if="signatureType && signatureImages[signatureType]"
                        :src="getSignature"
                        alt="signature"
                    />
                </div>
            </div>
        </div>
    </div>
    <GuestbookStatusesModal :guestbook="guestbook" />
</template>

<script>
    import Icon from '@/components/Icon.vue';
    import GuestbookStatusesModal from '@/components/GuestbookStatusesModal.vue';
    import { CONFIG } from "@/config.js"

    export default {
        components: {
            Icon,
            GuestbookStatusesModal,
        },
        data() {
            return {
                guestbook: {},
                modalTitle: null,
                signatureType: null,
                signatureImages: {
                    arrival: null,
                    departure: null
                }
            }
        },
        mounted() {
            this.setupCanvas();
        },
        created() {
            this.getGuestbook();
        },
        methods: {
            getGuestbook() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/guestbooks/${this.$route.params.id}`)
                .then(response => {
                    this.guestbook = response.data;

                    const arrivalImg = this.guestbook.signatures.find(sig => sig.is_arrival);
                    const departureImg = this.guestbook.signatures.find(sig => !sig.is_arrival);

                    this.signatureImages.arrival = arrivalImg?.image || null;
                    this.signatureImages.departure = departureImg?.image || null;
                })
                .catch(error => {
                    console.error("Error loading guestbook", error);
                });
            },
            goToEdit() {
                this.$router.push({
                    name: "guestbookEditView",
                    params: {
                        slug: this.$route.params.slug,
                        id: this.guestbook.id,
                    }
                })
            },

            openSignatureModal(type) {
                this.signatureType = type;
                this.modalTitle = this.$t("guestbook.signature." + type)
                this.clearCanvas();
            },
            openViewModal(type) {
                this.signatureType = type;
                this.modalTitle = this.$t("guestbook.signature." + type)
            },
            setupCanvas() {
                this.canvas = this.$refs.canvas
                this.ctx = this.canvas.getContext("2d");

                this.canvas.addEventListener("mousedown", this.startDrawing)
                this.canvas.addEventListener("mousemove", this.draw);
                this.canvas.addEventListener("mouseup", this.stopDrawing);
                this.canvas.addEventListener("mouseleave", this.stopDrawing);
            },
            startDrawing(e) {
                this.drawing = true;
                this.ctx.beginPath();
                this.ctx.moveTo(e.offsetX, e.offsetY);
            },
            draw(e) {
                if (!this.drawing) return;
                this.ctx.lineTo(e.offsetX, e.offsetY);
                this.ctx.stroke();
            },
            stopDrawing() {
                this.drawing = false;
            },
            clearCanvas() {
                if (this.ctx) {
                    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                }
            },
            saveCanvas() {
                const isArrival = this.signatureType === "arrival";
                const guestbookId = this.guestbook.id;

                this.canvas.toBlob((blob) => {
                    if (!blob) return;

                    const filename = `${guestbookId}_${this.signatureType}.png`;
                    const file = new File([blob], filename, { type: "image/png" });

                    const formData = new FormData();
                    formData.append("guestbook", guestbookId);
                    formData.append("is_arrival", isArrival);
                    formData.append("file", file);

                    this.$store.getters.api.post(`/${this.$route.params.slug}/signatures/add`, formData)
                    .then(() => {
                        this.getGuestbook();
                    })
                    .catch(error => {
                        console.error("Error adding signature", error);
                    })
                }, "image/png");
            },
        },
        computed: {
            getSignature() {
                const slug = this.$route.params.slug;
                const guestbookId = this.guestbook.id;
                const type = this.signatureType;
                const timestamp = new Date().getTime();
                var url = CONFIG.api.baseUrl;
                url += `/${slug}/guestbooks/${guestbookId}/signatures/file?type=${type}&_=${timestamp}`;
                return url
            },
        }
    }
</script>

<style scoped>
    .canvas {
        border:1px solid #777070;
        background-color: white;
    }
</style>